import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SideNav } from 'AppSrc/core/components/side-nav/side-nav';
import { Header } from 'AppSrc/core/components/header/header';
import { GridOverlay } from 'AppSrc/core/components/dev-page/components/grid-overlay';
import 'AppSrc/core/style/components/app-layout/app-layout.css';
// import { AceOutageMessageBanner } from 'AppSrc/core/components/outage-banner/ace-outage-message-banner';

const showGridOverlay = process.env.NODE_ENV === 'development';

class AppLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sideNavOpen: true,
    };
    this.toggleNavOpen = this.toggleNavOpen.bind(this);
  }


  toggleNavOpen() {
    this.setState((prevState) => ({
      sideNavOpen: !prevState.sideNavOpen,
    }));
  }

  render() {
    const {
      children,
    } = this.props;
    const {
      sideNavOpen,
    } = this.state;

    return (
      <div
        id="app-layout"
      >
        {/* { window.location.pathname === '/' ? <AceOutageMessageBanner /> : ''} */}
        {
          showGridOverlay && (
            <GridOverlay />
          )
        }
        <Header />
        <div className={`app-layout-inner ${sideNavOpen ? 'app-layout-inner-nav-open' : ''}`}>
          <SideNav
            toggleNavOpen={this.toggleNavOpen}
            open={sideNavOpen}
          />
          {children}
        </div>
      </div>
    );
  }
}


AppLayout.propTypes = {
  children: PropTypes.node,
};



export {
  AppLayout,
};
